// extracted by mini-css-extract-plugin
export default {"form":"Td","inline":"Ud","inputWrapper":"Vd","input":"Wd","withoutLabel":"Xd","error":"Yd","label":"Zd"};